import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------


class SummaryMainScore extends React.Component {
  render() {
    let data = this.props.data;
    
    return (
      <div className="report-main-score">
        準備中
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default SummaryMainScore;